package com.fireavert.administration.users_page.edit_user_dialog.data_models.response

import com.fireavert.user.data_models.RolesModel
import kotlinx.serialization.Serializable

@Serializable
data class GetAllUserRolesResponse(
    val roles: List<RolesModel>
)